import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

function ViewSolution() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("viewSolution");
    if (!stored) {
      navigate(-1);
      return;
    }
    setData(JSON.parse(stored));
  }, [navigate]);

  if (!data) return <div className="p-4">Loading...</div>;

  return (
    <div>
      {/* ✅ HEADER — Title LEFT, Back Button RIGHT */}
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">

          {/* LEFT — Title + Breadcrumb */}
          <div className="page-header">
            <div>
              <h3 className="page-title mb-0">View Solution</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <Link to="/module-list">Modules</Link>
                <span className="mx-2">/</span>
                <Link to="/solutions-list">Solutions</Link>
                <span className="mx-2">/</span>
                <span>View</span>
              </nav>
            </div>
          </div>

          {/* RIGHT — Back Button */}
          <Link
            to="/solutions-list"
            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px", borderRadius: "8px" }}
          >
            <FaArrowLeft />
          </Link>
        </div>
      </div>

      {/* DETAILS */}
      <div className="main_page">
        <div className="st-wrapper-card p-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <strong>Name:</strong>
              <p>{data?.name}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Slug:</strong>
              <p>{data?.slug}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Module:</strong>
              <p>{data?.module?.name || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Status:</strong>
              <p>{data?.status === 1 ? "Active" : "Inactive"}</p>
            </div>
            <div className="col-md-12 mb-3">
              <strong>Short Description:</strong>
              <p>{data?.short_description || "-"}</p>
            </div>
            <div className="col-md-12 mb-3">
              <strong>Long Description:</strong>
              <p>{data?.long_description || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Hero Title:</strong>
              <p>{data?.hero_title || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Hero Subtitle:</strong>
              <p>{data?.hero_subtitle || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Meta Title:</strong>
              <p>{data?.meta_title || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Meta Description:</strong>
              <p>{data?.meta_description || "-"}</p>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/solutions-list")}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewSolution;